import EventBus from '../../../utils/event-bus'

export const defaultModuleName = 'navigation';
import * as types from './mutation-types';
import navigationApi from '@/modules/NavigationMenu/api';


export default {
  namespaced: true,
  state: {
    isOwnerCompaniesDataLoaded: false,
    isCurrentUserDataLoaded: false,
    isTerminalIsLoaded: false,
    selectedCompany: '',
    newCompanyDialog: false,
    canCompanyUseCoupon: false,
    companyFeatures: null,

  },
  getters: {
    isOwnerCompaniesDataLoaded(state) {
      return state.isOwnerCompaniesDataLoaded
    },
    isCurrentUserDataLoaded(state) {
      return state.isCurrentUserDataLoaded
    },
    selectedCompany(state) {
      return state.selectedCompany
    },
    newCompanyDialog(state) {
      return state.newCompanyDialog
    },
    selectedCompanyObject(state, getters, rootState, rootGetters) {
      return rootGetters['organization/myOrgs'].find((item) => {
        return item.name === rootGetters['navigation/selectedCompany']
      })
    },
    canCompanyUseCoupon(state) {
      return state.canCompanyUseCoupon
    },
    companyFeatures(state) {
      return state.companyFeatures
    },

  },
  mutations: {
    [types.IS_OWNER_COMPANIES_DATA_LOADED]: (state, payload) => {
      return state.isOwnerCompaniesDataLoaded = payload
    },
    [types.IS_CURRENT_USER_DATA_LOADED]: (state, payload) => {
      return state.isCurrentUserDataLoaded = payload
    },
    [types.CREATE_NEW_COMPANY_DIALOG]: (state) => {
      state.newCompanyDialog = !state.newCompanyDialog
    },
    [types.CREATE_NEW_COMPANY]: (state, payload) => {
      state.companies.push(payload)
    },
    [types.SELECTED_COMPANY]: (state, payload) => {
      state.selectedCompany = payload
    },
    [types.GET_CAN_COMPANY_USE_COUPONS]: (state, payload) => {
      state.canCompanyUseCoupon = payload
    },
    [types.UPDATE_COMPANY_FEATURES]: (state, payload) => {
      state.companyFeatures = payload
    },

  },
  actions: {
    isTerminalIsLoaded({commit, getters, dispatch}) {
      if (typeof getters['organization/myOrgs'][0] != "undefined") {
        commit(types.IS_OWNER_COMPANIES_DATA_LOADED, true)
      } else {
        commit(types.IS_OWNER_COMPANIES_DATA_LOADED, false)
        try {
          dispatch('organization/loadMyOrgs', {}, {root: true})
            .then(commit(types.IS_OWNER_COMPANIES_DATA_LOADED, true))
        } catch (e) {
          console.log('user:loadMyOrgs error')
        }
      }
    },
    isOwnerCompaniesDataLoaded({commit, getters, dispatch}) {
      if (typeof getters['organization/myOrgs'] != "undefined") {
        commit(types.IS_OWNER_COMPANIES_DATA_LOADED, true)
      } else {
        commit(types.IS_OWNER_COMPANIES_DATA_LOADED, false)
        try {
          dispatch('organization/loadMyOrgs', {}, {root: true})
            .then(commit(types.IS_OWNER_COMPANIES_DATA_LOADED, true))
        } catch (e) {
          console.log('user:loadMyOrgs error')
        }
      }
    },
    isCurrentUserDataLoaded({commit, dispatch}) {
      try {
        if (!!this.$store.getters['user/authUserInfo'])
          commit(types.IS_CURRENT_USER_DATA_LOADED, true)
      } catch (e) {
        commit(types.IS_CURRENT_USER_DATA_LOADED, false)
        try {
          dispatch('user/me', {}, {root: true}).then(commit(types.IS_CURRENT_USER_DATA_LOADED, true))
        } catch (e) {
          console.log('user::updated-info error')
        }
      }
    },

    newCompanyDialog({commit}, payload) {
      commit(types.CREATE_NEW_COMPANY_DIALOG, payload)
    },
    addCompany({commit}, payload) {
      commit(types.CREATE_NEW_COMPANY, payload)
    },
    async selectedCompany({commit, dispatch, getters}, payload) {
      commit(types.SELECTED_COMPANY, payload)
    },
    async getCanCompanyUseCoupon({commit, dispatch}, payload){
    const response = await dispatch('coupons/getCanCompanyUseCoupon', payload, {root: true});
      console.warn(response)
    },
    async getCompanyFeatures({commit}, payload){
      let {org_id} = payload

      const resp = await navigationApi.getCompanyFeatures(org_id);
      commit(types.UPDATE_COMPANY_FEATURES, resp.data)
    }
  }
}
